import * as ReselectModule from "reselect";
import { IRoleListState } from ".";
import { IApplicationState } from "..";

export const selectRoleList: ReselectModule.Selector<
  IApplicationState,
  IRoleListState
> = (state) => state.roleList;
